import { module } from 'modujs';
import gsap, { ScrollTrigger } from 'gsap/all';
import config from '../config';

gsap.registerPlugin(ScrollTrigger)

export default class View extends module {
    constructor(m) {
        super(m);

        this.$togglers = Array.from(this.$('toggler'))
        this.$projets = document.querySelector('.c-projet_listing_list')

        this.events = {
            click: {
                toggler: 'toggle'
            }
        }

        this.firstLoad = true
        this.currentIndex = -1
    }

    init() {
        this.updateTab(0)
    }

    toggle(e) {
        this.firstLoad = false

        this.$projets.classList.add('is-transitioning')
        this.updateTab(this.$togglers.findIndex($button => $button === e.curTarget))

        setTimeout(() => {
            window.scrollTo(0, 0)
        }, 950)

        setTimeout(() => {
            this.$projets.classList.remove('is-transitioning')
        }, 1000)
    }

    updateTab(index) {
        if (index === this.currentIndex) return;

        if (this.currentIndex > -1) {
            this.$togglers[this.currentIndex].classList.remove('is-active')
            this.$togglers[index].classList.add('is-active')
        }

        setTimeout(() => {
            if (index !== 0) {
                this.destroyParallax()
                this.$projets.classList.add('is-gallery')
            } else {
                this.$projets.classList.remove('is-gallery')
                this.initParallax()
            }

            if (this.firstLoad === true) return;

            this.call('update', null, 'LoadMore')
        }, 900)

        this.currentIndex = index
    }

    initParallax() {
        if (config.IS_TOUCH || window.innerWidth < 700) return;

        let projets = gsap.utils.toArray(".c-projet_listing_list:not(.is-gallery) .c-projet_imgs_wrapper");
        if (!projets) return;

        projets.forEach(projet => {
            this.projetContainer = projet.querySelector('.c-projet_imgs_container');

            if (this.projetContainer.scrollWidth < projet.clientWidth) return;

            let tl = gsap.to(this.projetContainer, {
                scrollTrigger: {
                    trigger: projet,
                    scrub: 0.5,
                    start: "top 79%",
                    end: "bottom 30%",
                    toggleActions: "restart complete reverse reset",
                },
                ease: "none",
                x: () => -(this.projetContainer.scrollWidth - projet.clientWidth) + 'px',
            })
        })
    }

    destroyParallax() {
        ScrollTrigger.getAll().forEach(t => {
            if (t.vars.id === 'header' || t.vars.id === 'load-more') {
                t.refresh()
            } else {
                t.kill()
            }
        });
    }

    updateTriggerLoadMore() {
        ScrollTrigger.getAll().forEach(t => {
            if (t.vars.id === 'load-more') {
                t.refresh()
            }
        });
    }

    destroy() {
        this.destroyParallax()

        super.destroy()
    }
}
